import clsx from "clsx";
import { NavLink, useNavigate } from "react-router-dom";
import { WorkspaceSwitcher } from "@/components/layout/WorkspaceSwitcher";

const navItems = [
  { to: "/today", icon: "home", label: "Today" },
  { to: "/tasks", icon: "folder_open", label: "Tasks" },
  { to: "/activity", icon: "notifications", label: "Activity" },
  { to: "/reports", icon: "bar_chart", label: "Reports" },
  { to: "/agents", icon: "smart_toy", label: "Agents" },
  { to: "/settings", icon: "settings", label: "Settings" }
];

export const DesktopSidebar = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <aside className="desktop-sidebar">
      <div className="desktop-sidebar-inner">
        <div className="mb-4">
          <p className="text-xs uppercase tracking-[0.15em] text-[var(--text-tertiary)]">Taskkar</p>
          <h1 className="mt-1 text-xl font-semibold">Execution Console</h1>
        </div>

        <div className="mb-4">
          <p className="mb-1 text-xs text-[var(--text-secondary)]">Workspace</p>
          <WorkspaceSwitcher />
        </div>

        <nav className="space-y-1" aria-label="Primary desktop navigation">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                clsx("flex items-center gap-2 rounded-lg px-3 py-2 text-sm", {
                  "bg-[var(--accent-primary-subtle)] text-[var(--accent-primary)]": isActive,
                  "text-[var(--text-secondary)] hover:bg-[var(--bg-tertiary)]": !isActive
                })
              }
            >
              <span className="material-symbols-outlined text-base">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <button type="button" className="btn mt-5 w-full" onClick={() => navigate("/tasks?sheet=add-task")}>
          + Add Task
        </button>
      </div>
    </aside>
  );
};
